export default "/images/c44deda23056aa4ab4e43632cd0173d1.png";